import styled from 'styled-components';
import PreviewTitle from 'gatsby-theme-vehicles/src/components/preview/components/title';

export default styled(PreviewTitle)`
  color: ${({ theme }) => theme.primaryColor};
  font-size: 1.375rem;
  line-height: ${({ theme }) => theme.baseLineHeight};
`;
